var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5408 1.20898H2.45703C1.25538 1.20898 0.28125 2.18311 0.28125 3.38476V21.6879C0.28125 22.8895 1.25538 23.8637 2.45703 23.8637H33.5408C34.7424 23.8637 35.7165 22.8895 35.7165 21.6879V3.38476C35.7165 2.18311 34.7424 1.20898 33.5408 1.20898Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5408 1.02539H2.45703C1.25538 1.02539 0.28125 1.99952 0.28125 3.20117V21.5043C0.28125 22.7059 1.25538 23.6801 2.45703 23.6801H33.5408C34.7424 23.6801 35.7165 22.7059 35.7165 21.5043V3.20117C35.7165 1.99952 34.7424 1.02539 33.5408 1.02539Z",
    fill: "url(#paint0_linear_172915_27518)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.45654 23.6801H13.8254L22.6863 1.02539H2.46484C1.26899 1.02539 0.289062 2.00532 0.289062 3.20117V21.5043C0.289062 22.7001 1.26899 23.6801 2.46484 23.6801H2.45654Z",
    fill: "url(#paint1_linear_172915_27518)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6151 8.40697L14.4366 15.6496H16.3221L17.5007 8.40697H15.6151ZM12.8502 8.40697L11.0525 13.3884L10.8399 12.3157L10.84 12.316L10.7932 12.0756C10.5756 11.6067 10.0717 10.7156 9.12023 9.95505C8.83893 9.73025 8.55537 9.5384 8.28125 9.37452L9.91506 15.6496H11.8796L14.8796 8.40697H12.8502ZM20.209 10.4177C20.209 9.59882 22.0453 9.70403 22.8522 10.1487L23.1212 8.59315C23.1212 8.59315 22.2908 8.27734 21.4253 8.27734C20.4895 8.27734 18.2675 8.68656 18.2675 10.6749C18.2675 12.5463 20.8755 12.5695 20.8755 13.552C20.8755 14.5345 18.5364 14.3589 17.7644 13.7391L17.4839 15.365C17.4839 15.365 18.3258 15.7742 19.6125 15.7742C20.899 15.7742 22.8404 15.1077 22.8404 13.2947C22.8404 11.4117 20.209 11.2363 20.209 10.4177ZM27.9032 8.40697H26.3872C25.6872 8.40697 25.5167 8.94672 25.5167 8.94672L22.7048 15.6496H24.6701L25.0632 14.5738H27.4603L27.6814 15.6496H29.4127L27.9032 8.40697ZM25.6066 13.0876L26.5974 10.3772L27.1548 13.0876H25.6066Z",
    fill: "#005BAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2316 9.08725C10.2316 9.08725 10.1536 8.43359 9.32037 8.43359H6.29327L6.25781 8.55644C6.25781 8.55644 7.71288 8.85306 9.10883 9.96435C10.4429 11.0265 10.878 12.3505 10.878 12.3505L10.2316 9.08725Z",
    fill: "#F6AC1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172915_27518",
    x1: 17.9986,
    y1: 23.6792,
    x2: 17.9986,
    y2: 1.02282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172915_27518",
    x1: 9.2624,
    y1: 0.42456,
    x2: 13.7002,
    y2: 24.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.8dfacc4a2337f8097ac291193d4185cf.svg";
export { ForwardRef as ReactComponent };